import { useCallback, useEffect, useRef } from 'react';

const UK_BOUNDS = { minLat: 49.5, maxLat: 61.0, minLng: -8.5, maxLng: 2.5 };

function isValidUK(lat, lng) {
	return lat >= UK_BOUNDS.minLat && lat <= UK_BOUNDS.maxLat
	    && lng >= UK_BOUNDS.minLng && lng <= UK_BOUNDS.maxLng;
}

// Reusable outside the hook (e.g. Site Search "zoom to selection").
export function fitMapToSites(map, sitesToFit) {
	if (!map || !sitesToFit || sitesToFit.length === 0) return;
	var valid = sitesToFit.filter(function(s) {
		var lat = parseFloat(s.latitude);
		var lng = parseFloat(s.longitude);
		return !isNaN(lat) && !isNaN(lng) && isValidUK(lat, lng);
	});
	if (valid.length === 0) return;
	var lats = valid.map(function(s) { return parseFloat(s.latitude);  });
	var lngs = valid.map(function(s) { return parseFloat(s.longitude); });
	map.fitBounds([
		[Math.min.apply(null, lats), Math.min.apply(null, lngs)],
		[Math.max.apply(null, lats), Math.max.apply(null, lngs)],
	], { padding: [40, 40], maxZoom: 12 });
}

export function useAutozoom(mapRef, visibleSites, loading, hideInactive) {
	const prevLoadingRef  = useRef(false);
	const initialLoadDone = useRef(false);
	const mountedRef      = useRef(false);
	const prevHideRef     = useRef(hideInactive);

	const autozoom = useCallback(function(sitesToFit) {
		fitMapToSites(mapRef.current, sitesToFit);
	}, [mapRef]);

	// After Apply / Reset — skip the very first load on mount
	useEffect(function() {
		var wasLoading = prevLoadingRef.current;
		prevLoadingRef.current = loading;
		if (!wasLoading || loading) return;
		if (!initialLoadDone.current) {
			initialLoadDone.current = true;
			return;
		}
		autozoom(visibleSites);
	}, [loading]);

	// After Active Only toggle — NOT on initial mount
	useEffect(function() {
		if (!mountedRef.current) {
			mountedRef.current = true;
			prevHideRef.current = hideInactive;
			return;
		}
		if (hideInactive === prevHideRef.current) return;
		prevHideRef.current = hideInactive;
		autozoom(visibleSites);
	}, [hideInactive]);
}